import { useTranslation } from "react-i18next";
import "../css/index.css";
import bgImg from '../assets/Animation-1-2.gif';
import Typer from "../components/Typewriter";
const Home = () => {
	const { t } = useTranslation(["home"]);

	return (
        <div>
        <div className="mp">
		    <section className="sec sec1 mp" style={{
              backgroundImage:`url(${bgImg})`       
              }}>
            <div className="cont">
                {/* <h1>{t("section1.h1")}</h1> */}
                <div>
                    <Typer
                        heading={t("section1.typeWriter-heading")}
                        dataText={[                        
                           `${t("section1.typeWriter-1")}`,
                           `${t("section1.typeWriter-2")}`,
                           `${t("section1.typeWriter-3")}`,
                           `${t("section1.typeWriter-4")}`,
                        ]} 
                     />
                </div>
                <p>{t("section1.p")}</p>
            </div>
           </section>
         </div>
          <section className="sec sec2">
          <h1 className="heading1">
                {t("section2.h1")}
            </h1>
            <h4 className="heading2">{t("section2.h4")}</h4>
            <p className="desc">{t("section2.p")}</p>
          </section>
          <section className="sec sec3">
            <div className="companies">
                <img src={require("../assets/Australian-Government-png-01-768x511.png")} alt="Australian-Government" />
                <img src={require("../assets/PARRAMATTA-768x682.png")} alt="PARRAMATTA" />
                <img src={require("../assets/Polyglot-768x682.png")} alt="Polyglot" />
            </div>
        </section>
        <section className="sec sec4">
            <h1 className="heading1">{t("sec4.h1")}</h1>
            <h4 className="heading2">
                {t("sec4.h4")}
            </h4>
            <div className="subsec1">
            <img id="clockImg" src={require("../assets/image-2-768x384.png")} alt="clock img" />
            <div>
            <h3 className="heading3">{t("sec4.sub1h3")}</h3>
            <p className="desc">
                {t("sec4.sub1p")}
            </p>
            </div>
            </div>
            <div className="subsec2">
            <img src={require("../assets/handShake.png")} alt="hand shake" />
               <div>
                  <h3 className="heading4">{t("sec4.sub2h3")}</h3>
                  <p className="desc">
                  {t("sec4.sub2p")}
                  </p>
               </div>
            </div>
            <div className="subsec3">
               <img src={require("../assets/execution.png")} alt="execution" />
               <div>
                  <h3 className="heading5">{t("sec4.sub3h3")}</h3>
                  <p className="desc">{t("sec4.sub3p")}</p>
               </div>
            </div>
            <div className="subsec4">
               <img src={require("../assets/communicate.png")} alt="communicate" />
                  <div>
                     <h3 className="heading6">{t("sec4.sub4h3")}</h3>
                     <p className="desc">{t("sec4.sub4p")}</p>
                  </div>
            </div>
            <div className="subsec5">
            <img src={require("../assets/work-together.png")} alt="work together" />
               <div>
                  <h3>{t("sec4.sub5h3")}</h3>
                  <p>{t("sec4.sub5p")}</p>
               </div>
            </div>
            <div className="btns">
                <a href="/contact" className="getStartedBtn">{t("sec4.getStarted")}</a>
                <a href="/services" className="ourService">{t("sec4.ourService")}</a>
            </div>
            <div>
               <h1 className="subHeading">{t("sec4.subHeading")}</h1>
            </div>
        </section>
        <section className="sec sec5">
         <div className="container">
            <div className="msp">
               <h1>{t("msp.h1")}</h1>
               <img src={require("../assets/image-7-icon-1B.png")} alt="boat img" />
               <h2>{t("msp.firstH2")}</h2>
               <p>{t("msp.firstP")}</p>
               <img src={require("../assets/mail.png")} alt="mail img" />
               <h2>{t("msp.secH2")}</h2>
               <p>{t("msp.secP")}</p>
               <img src={require("../assets/support.png")} alt="support" />
               <h2>{t("msp.thirdH2")}</h2>
               <p>{t("msp.thirdP")}</p>
               <img src={require("../assets/plant.png")} alt="unable to scale" />
               <h2>{t("msp.fourthH2")}</h2>
               <p>{t("msp.fourthP")}</p>
            </div>
            <div className="hdit" 
            style={{backgroundImage:`url(${require("../assets/blue-background.png")})`,
            backgroundRepeat:"no-repeat",
            backgroundPosition:"center",
            backgroundSize:"100%"}}
            >
             <h1>{t("hdit.h1")}</h1>
               <img src={require("../assets/rboat.png")} alt="boat img" />
               <h2>{t("hdit.firstH2")}</h2>
               <p>{t("hdit.firstP")}</p>
               <img src={require("../assets/rtime.png")} alt="mail img" />
               <h2>{t("hdit.secH2")}</h2>
               <p>{t("hdit.secP")}</p>
               <img src={require("../assets/rteam.png")} alt="support" />
               <h2>{t("hdit.thirdH2")}</h2>
               <p>{t("hdit.thirdP")}</p>
               <img src={require("../assets/rgrowth.png")} alt="unable to scale" />
               <h2>{t("hdit.fourthH2")}</h2>
               <p>{t("msp.fourthP")}</p>

            </div>
         </div>
        </section>
      </div>
	);
};

export default Home;